import constants from '../constants.js';

const EnhancedLogsItem = {
  displayAs: constants.DISPLAY_AS.ENHANCED_LOG_ITEM
};

const EnhancedLogsId = {
  displayName: 'Identifier',
  dataAt: 'id',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
};

const EnhancedLogsPassengerIdentifier = {
  displayName: 'Passenger Identifier',
  dataAt: 'PassengerIdentifier',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
};

const EnhancedLogsRequestDateTime = {
  displayName: 'Request Date Time',
  dataAt: 'RequestDate',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
};

const EnhancedLogsIsError = {
  displayName: 'Is Error',
  dataAt: 'IsError',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
};

const EnhancedLogsRequestType = {
  displayName: 'Request Type',
  dataAt: 'RequestType',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
};

const EnhancedLogsRequestMessage = {
  displayName: 'Request Message',
  dataAt: 'RequestMessage',
  displayAs: constants.DISPLAY_AS.TEXT_AREA,
  disabled: true,
};

const EnhancedLogsResponseMessage = {
  displayName: 'Response Message',
  dataAt: 'ResponseMessage',
  displayAs: constants.DISPLAY_AS.TEXT_AREA,
  disabled: true,
};

const EnhancedLogsGrid = {
  rootNode: true,
  displayName: 'Enhanced Logs',
  iconClass: 'fa-hammer',
  displayAs: constants.DISPLAY_AS.PAGING_GRID,
  canCopyItem: false,
  canAddNew: false,
  endpoint: 'EnhancedLogging',
  gridCols: [
    
    { name: 'RequestDate', field: 'RequestDate', cellFilter: 'dateDisplay',width: '165' },
    { name: 'IsError', field: 'IsError',width:'50' },
    { name: 'RequestType', field: 'RequestType',width: '200' },
    { name: 'RequestMessage', field: 'RequestMessage' },
    { name: 'ResponseMessage', field: 'ResponseMessage' }
  ],
  children: [
    EnhancedLogsItem
  ],
  filterColumns: "EnhancedLogsSearchTypes",
  defaultFilteredColumn: "PassengerIdentifier",
  defaultSort: [
    {
      "column":"RequestDate",
      "Order": "Desc"
    }
  ]
};

const EnhancedLogResource = {
  rootNode: true,
  displayName: "Enhanced Logs",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  iconClass: "fa-cog",
  dataAt: "",
  children: [EnhancedLogsGrid],
  noButtons: true
};

export default {
  EnhancedLogsGrid,
  EnhancedLogsId,
  EnhancedLogsPassengerIdentifier,
  EnhancedLogsRequestDateTime,
  EnhancedLogsIsError,
  EnhancedLogsRequestType,
  EnhancedLogsRequestMessage,
  EnhancedLogsResponseMessage,
  EnhancedLogResource,
  EnhancedLogsItem
};



// WEBPACK FOOTER //
// ./src/config/fields/enhancedLogs.js